import React, { useEffect, useState } from "react";
import { Snackbar, Button } from "@mui/material";
import ProposalTemplateDialog from "./dialogs/ProposalTemplateDialog";
import { decoratedFetch } from "../req_utils";
import { GENESIS_LOGO_COLOR } from "../constants";
import ThemedDataGridPro from "./ThemedDataGridPro";
import { useSelector } from "react-redux";

const ProposalTemplates = () => {
  const employee_branch_id = useSelector((state) => state.employee_branch_id);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [proposalTemplates, setProposalTemplates] = useState([]);
  const [proposalTemplatesLoading, setProposalTemplatesLoading] =
    useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [gridKey, setGridKey] = useState(false);

  const columns = [{ field: "name", headerName: "Name", flex: 1 }];

  const handleRowClick = (params) => {
    setSelectedItem(params.id);
    setOpen(true);
  };

  const updateProposalTemplate = (proposalTemplate) => {
    setProposalTemplates(
      proposalTemplates.map((template) =>
        template.id === proposalTemplate.id ? proposalTemplate : template,
      ),
    );
  };

  const refreshProposalTemplatesAndClose = () => {
    listProposalTemplates();
    handleDialogClose();
  };

  const handleDialogClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  const listProposalTemplates = () => {
    if (!employee_branch_id) return;
    
    decoratedFetch(`/list_proposal_templates?branch_id=${employee_branch_id}`)
      .then((response) => response.json())
      .then((data) => {
        const mappedData = data.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        setProposalTemplates(mappedData); // Set the new array to the state
        setGridKey(!gridKey);
      })
      .catch((error) => {
        console.error(`Error listing proposal templates: ${error}`);
      });
  };

  useEffect(() => {
    if (!employee_branch_id) return;
    listProposalTemplates();
  }, [employee_branch_id]);

  return (
    <div>
      <Snackbar
        sx={{
          ".MuiSnackbarContent-root": {
            backgroundColor: GENESIS_LOGO_COLOR,
            minWidth: 0,
          },
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: 10,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ my: "5px" }}
          onClick={() => setOpen(true)}
        >
          Create Proposal Template
        </Button>
      </div>
      <div style={{ height: "auto", width: "100%" }}>
        <ThemedDataGridPro
          key={gridKey}
          rows={proposalTemplates}
          columns={columns}
          onRowClick={handleRowClick}
          loading={proposalTemplatesLoading}
          localeText={{ noRowsLabel: "No Templates" }}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cellCheckbox:focus, & .MuiDataGrid-cellCheckbox:focus-within":
              {
                outline: "none",
              },
          }}
        />
      </div>
      <ProposalTemplateDialog
        open={open}
        proposalTemplateId={selectedItem}
        handleClose={handleDialogClose}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarMessage={setSnackbarMessage}
        refreshProposalTemplates={listProposalTemplates}
        refreshProposalTemplatesAndClose={refreshProposalTemplatesAndClose}
      />
    </div>
  );
};

export default ProposalTemplates;
